import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { VaccineIcon } from '../../../assets/icons';
import useStyles from '../styles';
import { useStepperContext } from '../hooks/useStepper';
import { VaccinationStatusType } from '../../../services/models';

interface VaccineFifthStepProps {
  onStatusChanged: (status: VaccinationStatusType) => void;
}

function VaccineFifthStep({ onStatusChanged }: VaccineFifthStepProps) {
  const classes = useStyles();
  const { changePage } = useStepperContext();

  const handleReturn = useCallback(() => {
    onStatusChanged(VaccinationStatusType.Scheduled);
    changePage(0);
  }, [changePage, onStatusChanged]);

  return (
    <Grid container direction="column">
      <Grid item>
        <Box px={2} className={classes.disclaimer}>
          <img src={VaccineIcon} alt="vaccine-icon" />
          <Typography variant="h1">Prontinho!</Typography>
          <Typography>
            Agora é só aguardar o dia do agendamento e comparecer ao local com
            15 minutos de antecedência, para tomar a vacina.
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box mt={10} textAlign="center">
          <Button
            component={Link}
            variant="outlined"
            to={{
              pathname: '/minha-saude/vacina',
              key: btoa(Math.random().toString()),
            }}
            onClick={handleReturn}
            className={classes.button}
          >
            Ver meu Agendamento
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}

export default VaccineFifthStep;
